import { render } from "./AdSettings.vue?vue&type=template&id=379c0db4&scoped=true&ts=true"
import script from "./AdSettings.vue?vue&type=script&lang=ts"
export * from "./AdSettings.vue?vue&type=script&lang=ts"

import "./AdSettings.vue?vue&type=style&index=0&id=379c0db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379c0db4"]])

export default __exports__